// 新东方投资
export const invest = [{
  imgUrl: 'http://file.xdf.cn/neworiental/images/invest/jkstar.png',
  organization: '极客晨星',
  url: 'https://www.jikestar.com',
  phone: '400-810-8918',
  advisory: 'http://dct.zoosnet.net/LR/Chatpre.aspx?id=DCT89484319&lng=cn',
  style: 'height: 45px'
}]



// WEBPACK FOOTER //
// ./src/api/js/home/invest.js